import React from "react";
import TransferList from "./TransferList";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

export default function CustomerCgSearchResult() {
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const { custsCGs, selectedCustsCGs } = setupState;

	return (
		<Box
			sx={{
				mt: 1,
				p: 2,
				borderLeft: 1,
				borderColor:"#c6c6c6"
			}}
		>
			<Box sx={{ mt: 0 }}>
				<Typography
					sx={{ fontWeight: "bold" }}
					leftList={custsCGs}
					rightList={selectedCustsCGs}
				>
				</Typography>
			</Box>

			<Box sx={{ mt: 1 }}>
				<TransferList
					leftList={custsCGs}
					rightList={selectedCustsCGs}
					leftState={"custsCGs"}
					rightState={"selectedCustsCGs"}
					isCustomer = {true}
				/>
			</Box>
		</Box>
	);
}
